export const goPage = (_p) => {
  window.location.href = _p;
};